import * as React from "react";
import { useState } from "react";
import { Form, Link, Params, useLoaderData, useNavigate, useSubmit, } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";
import { Contact } from "../../../stores/contact/contact-store";
import "./contact-show.css";
import { RootStore } from "../../../stores/root-store";
import { TransportError } from "../../../stores/data-transporter";

export async function loader(params: Params, rootStore: RootStore) {
    if (params.contactId !== undefined) {
        try {
            const contactId = parseInt(params.contactId) || 0;
            const rootStoreSession = rootStore.newSession();
            return await rootStoreSession.contactStore.load(contactId);
        } catch (error: TransportError) {
            throw new Response("", {
                status: error.statusCode,
                statusText: "Kontakt wurde nicht gefunden",
            });
        }
    }

    throw new Response("", {
        status: 404,
        statusText: "Kontakt wurde nicht gefunden",
    });
}

export default function ContactShow(): JSX.Element {
    const contact = useLoaderData() as Contact;
    const submit = useSubmit();
    const navigate = useNavigate();
    const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);

    return (
        <div className="contactShow">
            <ul>
                <li>{contact.body}</li>
                <li className="name">
                    {contact.firstName} {contact.lastName}
                </li>
            </ul>
            <ul>
                <li>
                    {contact.street} {contact.streetNr}
                </li>
                {contact.additionalAddressLine !== null && (
                    <li>{contact.additionalAddressLine}</li>
                )}
                <li>
                    {contact.zipCode} {contact.city}
                </li>
            </ul>
            <ul>
                <li>{contact.email}</li>

                <li>{contact.phone}</li>
            </ul>
            <div className="buttons">
                <Button type="button" onClick={() => navigate(-1)}>Zurück</Button>
                <Link to={`/kontakte/${contact.id}/aendern`}>
                    <Button type="button">Bearbeiten</Button>
                </Link>
                <Form id="deleteContactForm" method="delete" action={`/kontakte/${contact.id}/loeschen`}>
                    <Modal
                        size="mini"
                        onClose={() => setShowConfirmDeleteDialog(false)}
                        onOpen={() => setShowConfirmDeleteDialog(true)}
                        open={showConfirmDeleteDialog}
                        trigger={
                            <a href="#"
                               onClick={(e) => {
                                   e.preventDefault();
                                   setShowConfirmDeleteDialog(true);
                               }}
                            >
                                Löschen
                            </a>
                        }
                        dimmer="blurring"
                    >
                        <Modal.Content>
                            Kontakt "{contact.firstName} {contact.lastName}" wirklich löschen?
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={() => setShowConfirmDeleteDialog(false)}>
                                Abbrechen
                            </Button>
                            <Button
                                onClick={() => {
                                    setShowConfirmDeleteDialog(false);
                                    submit(document.getElementById("deleteContactForm") as HTMLFormElement);
                                }}
                            >
                                Löschen
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </Form>
            </div>
        </div>
    );
}
